/**
 * 서버 오류 메시지 추출 (aipark-front #266 P3)
 *
 * BE 는 `BadRequestException` 을 `@ResponseStatus(BAD_REQUEST)` 로만 표시하고,
 * `AdminInvoiceRefundController` 에는 다른 컨트롤러들이 가진
 * `@ExceptionHandler(BadRequestException.class)` 가 없다. Spring 의
 * `server.error.include-message` 기본값이 `never` 라 이 경로의 400 은 본문에 사유 문장이
 * **비어 올 수 있다.**
 *
 * ⚠️ 코드만으로는 단정할 수 없다 — aivatar `.claude/local/qa-26w33.md` 에 같은 형태의 예외
 * (`@ResponseStatus` 만 붙은 `NotEnoughCreditException`)에서 메시지가 정상 전달됐다는 실측
 * 반증이 있다. 그래서 **"사유가 없다" 를 빈 문자열로 뭉개지 않고 `null` 로 구분해서 낸다.**
 * 호출부가 "서버가 거절했다 + 사유는 못 받았다" 를 따로 안내할 수 있어야 담당자가 없는
 * 정책 문제를 찾지 않는다.
 *
 * 산정 API 3종의 400 은 이쪽이 아니다 — 그건 `reason` 을 담은 **정상 응답**이고
 * `utils/quoteError` 의 `quoteOrReason` 이 다룬다.
 */

/** 서버가 준 사유. 없으면 null — 빈 문자열로 만들지 않는다 */
export const apiErrorMessage = (e: any): string | null => {
  const data = e?.response?.data
  const candidates = [data?.message, data?.error, data?.reason, e?.message]
  const found = candidates.find((v) => typeof v === 'string' && v.trim())
  return found ? String(found).trim() : null
}

/** 사유를 못 받았을 때 대신 보여줄 문구가 있는 경우 */
export const apiErrorMessageOr = (e: any, fallback: string): string => apiErrorMessage(e) ?? fallback
